import React, {useEffect, useState} from "react";
import {Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import Dict from "../../helper/dict";

const ReferrerIncomeList = ({incomes}) => {

  const [incomeList, setIncomeList] = useState(incomes?.length > 0 ? incomes : null);


  useEffect(() => {
    setIncomeList(incomes)
  }, [incomes]);

  return (
    <>
      {incomeList && incomeList.length > 0 &&
        incomeList.map(({
                          referee_name,
                          referee_phone,
                          referral_type,
                          product_type,
                          referrer_share,
                          agent_name,
                          created_at,
                        }, index) => (
          <div
            key={index}
            className="flex flex-col w-full pb-3 pt-3 border-b-2 last:pb-0"
          >
            <div className="flex flex-row w-full justify-between">
              <div className="flex flex-col">
                <Typography color="blue-gray" variant="h6">
                  {`${persianNumberFormat(index + 1)} - ${referee_name}`}
                </Typography>
              </div>
              <div className="flex flex-col">
                <Typography variant="small" color="blue-gray">
                  {persianNumberFormat(`${referee_phone.slice(-2)}***${referee_phone.slice(0, 6)}`)}
                </Typography>
              </div>
            </ div>
            <div className="flex flex-row w-full justify-between">
              {referral_type === "register_bonus" &&
                <div className="flex flex-col">
                  <Typography color="blue-gray" variant="paragraph">
                    {`${persianNumberFormat(referrer_share, true)} ریال بابت پاداش ثبت نام`}
                  </Typography>
                </div>
              }
              {referral_type === "purchase_cashback" &&
                <div className="flex flex-col">
                  <Typography color="blue-gray" variant="paragraph">
                    {`${persianNumberFormat(referrer_share, true)} ریال بابت دریافت ${Dict(product_type)} از ${agent_name} `}
                  </Typography>
                </div>
              }
              <div className="flex flex-col">
                <Typography color="blue-gray" variant="paragraph">
                  {`${persianNumberFormat(created_at.split(" ")[1])} ${persianNumberFormat(created_at.split(" ")[0])}`}
                </Typography>
              </div>
            </div>


          </div>
        ))}
      {incomeList && incomeList.length === 0 &&
        <>
          <Typography color="gray" className="textCenter">
            رزرو فعالی ندارید
          </Typography>
        </>

      }
    </>
  );
};

export default ReferrerIncomeList;
